<template lang="pug">
  .height-100
    h3.title Gestión de excepciones de permisos
    p
    
    transition-group.contenedor-box(name="fade-smooth-two", tag="div")
      .box.nueva-solicitud(v-if="mostrarSolicitud", key="nueva_solicitud")
        nueva-solicitud-vacaciones(
          @close="mostrarSolicitud = false"
          :is-excepcion="true"  
        )
</template>

<script>
import SolicitudPermisosComponent from './Component_Permisos_Solicitud'
export default {
  name: 'permisos-excepcion',
  components: {
    'nueva-solicitud-vacaciones' : SolicitudPermisosComponent
  },
  data () {
    return {
      mostrarSolicitud: true
    }
  },
  watch : {
  },
  created () {
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
  .contenedor-box
    display flex
    justify-content center
    flex-direction column
    position relative
    >*
      transition all .5s
      width 100%  
</style>



// WEBPACK FOOTER //
// View_Permisos_Excepcion.vue?9ebf829e